export const SOCIAL_DOCK_DESKTOP_MEDIA_QUERY = '(min-width: 768px)'

export type SocialDockVisibilityInput = {
  workspaceAvailable: boolean
  isDesktopViewport: boolean
  pathname: string
  search: string
}

export function shouldRenderSocialChatDock({
  workspaceAvailable,
  isDesktopViewport,
  pathname,
  search,
}: SocialDockVisibilityInput): boolean {
  if (!workspaceAvailable || !isDesktopViewport)
    return false

  const params = new URLSearchParams(search)
  if (pathname === '/dashboard' && params.get('tab') === 'social')
    return false

  return true
}
